export const sortMenus = [
    {
        name: 'Price Low to High',
    },
    {
        name: 'Price High to Low',
    },
];